namespace advisorop.components.servicer {

    export class WorkflowMonitorController {

        $router;
        iAmReady: any;

        dg: DevExpress.ui.dxDataGridOptions;
        dgComponent: DevExpress.ui.dxDataGrid;

        workflowInstancesLoaded = false;

        selWorkflowIndex?: number = null;

        workflowMaster: domains.IWorkflowMaster;

        workflowInstances: domains.IWorkflowInstance[] = [];
        workflowInstanceDetail: domains.IWorkflowInstance[] = [];
        workflowInstanceDetailReady: boolean[] = [];
        workflowMasterId;
        showMasterLabel;

        workflowShapeColIds: string[] = [];

        numFixedColumns: number = 3;

        // WE EXCLUDE HIDDEN COLUMNS FROM THIS COUNT
        numVisibleFixedColumns: number = 3;

        user: domains.IUser;
        isAdvisorUser: boolean = false;
        isServicerUser: boolean = false;
        isTraderUser: boolean = false;
        accountStatusOpen = domains.AccountStatus.OPEN;


        static $inject = ["generalService", "identityService", "servicerService", "workflowApi", "$filter"];
        constructor(private gs: services.GeneralService,
            private ids: services.IdentityService,
            private servicerService: services.ServicerService,
            private workflowApi: services.WorkflowApi,
            private filter: any) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "WorkflowInstances"
                },
                bindingOptions: {
                    dataSource: "vm.workflowInstances",
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: { pageSize: 10 },
                //rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no workflow instances",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                //filterRow: { visible: true },
                //headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "id", visible: false },
                    { dataField: "dateCreated", caption: "Created", dataType: 'date', format: 'shortDate', sortIndex: 0, sortOrder: "desc", width: "70" },
                    { dataField: "description", caption: "Item", cellTemplate: "colWorkflowDesc", width: "200" },
                    { dataField: "notes", caption: "Notes", width: "200" },
                    //{ dataField: "currentSteps", caption: "Current Step(s)" },
                    //{ dataField: "xx", caption: "Actions", cellTemplate: "btnActions", width: "200" }
                ],
                onCellPrepared: (e) => this.onCellPrepared(e),
                onInitialized: (e) => {
                    this.dgComponent = e.component;
                },
            };
        }

        viewWorkflow(workflowInstanceId: number): void {
            this.loadWorkflowInstanceDetail(workflowInstanceId);
        }

        workflowInstanceDetailIsReady(index: number): boolean {
            return !!this.workflowInstanceDetailReady[index];
        }

        workflowInstanceDetailModel(index: number) {
            return this.workflowInstanceDetail[index];
        }

        numberToCurrency(x: number) {
            return "$"+x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }


        htmlWorkflowItemDescription(instance: domains.IWorkflowInstance): string {
            var ret = "";
            var i = 0;
            if (instance.accountDesc) {
                ret += "<strong>Account: </strong>" + instance.accountDesc;
                i++
            }
            if (instance.householdDesc) {
                if (i > 0)
                    ret += "<br />"
                ret += "<strong>Household: </strong>" + instance.householdDesc;
                i++;
            }
            if (instance.investorDesc) {
                if (i > 0)
                    ret += "<br />"
                ret += "<strong>Investor: </strong>" + instance.investorDesc;
                i++;
            }
            if (this.workflowMaster.linkToValue && instance.biTargetValue != null && instance.biTargetValue != undefined) {
                if (i > 0)
                    ret += "<br />"
                ret += "<strong>Value: </strong>" + this.numberToCurrency(instance.biTargetValue);
            }
            return ret;
        }

        loadWorkflowMasterAndInstances(workflowMasterId: number): void {
            // Delete workflow shape columns from prior workflow model
            this.workflowShapeColIds.forEach(i => this.dgComponent.deleteColumn(i));
            this.workflowShapeColIds = [];

            this.workflowApi.getWorkflowMaster(workflowMasterId)
                .then((response) => {
                    if (response.data) {
                        this.workflowMaster = response.data as domains.IWorkflowMaster;
                        // Add custom columns to grid for the linear representation of the workflow
                        //console.log("WORKFLOWMASTER", this.workflowMaster);
                        var i = 0;
                        this.workflowMaster.linearWorkflow.forEach(c => {
                            this.workflowShapeColIds.push(c.id)
                            const df = "linearLatestSteps[" + i + "]";
                            this.dgComponent.addColumn(
                                {
                                    name: c.id, dataField: df, caption: c.name, allowEditing: false,
                                    width: 90, cellTemplate: "tmpAction20", visible: (i>0)
                                }
                            );
                            i++;
                        });
                        this.loadWorkflowInstances(workflowMasterId);
                    }
                }).
                catch(err => {
                    toastr.error("Cannot fetch workflow master!", err);
                });
        }

        buildInstanceLinearLatestSteps(instance: domains.IWorkflowInstance): void {
            instance.linearLatestSteps = [];
            this.workflowMaster.linearWorkflow.forEach(c => {
                const existingStep = instance.diagram.shapes.find(w => w.step && w.step.shapeId == c.aoId);
                if (existingStep) {
                    instance.linearLatestSteps.push(existingStep);
                } else {
                    instance.linearLatestSteps.push(c);
                }
            });

            // Identify the most recently completed step
            // This is an optimization done here so to avoid doing it while processing the grid.
            var completedSteps = instance.linearLatestSteps
                .filter(w => w.step && w.step.workflowStepStatus == domains.WorkflowStepStatus.COMPLETED)
                .map(w => ({
                    id: w.step.id,
                    endDate: w.step.endDate
                }));
            if (completedSteps.length) {
                // sort in descending date order so that the first element is the latest completed step
                completedSteps.sort(function (a, b) {return +new Date(b.endDate) - +new Date(a.endDate);})
                const ind = instance.linearLatestSteps.findIndex(w => w.step && w.step.id == completedSteps[0].id);
                instance.linearLatestSteps[ind].step.isLatestCompletedStep = true;
            }
        }

        loadWorkflowInstances(workflowMasterId: number): void {
            this.workflowInstancesLoaded = false;
            this.workflowInstances = [];
            this.workflowInstanceDetail = [];
            this.workflowInstanceDetailReady = [];
            this.workflowApi.getWorkflowInstances(workflowMasterId)
                .then((response) => {
                    if (response.data) {
                        this.workflowInstances = response.data;

                        //    // For each instance, set the "currentSteps" (list of current steps) on the object by iterating through the steps that were returned
                        //    if (this.workflowInstances && this.workflowInstances.length > 0) {
                        //        this.workflowInstances.forEach(i =>
                        //            i.diagram?.shapes?.length && i.diagram.shapes.sort((a, b) => (a.id < b.id) ? 1 : -1).forEach(s => s.step
                        //                && (s.step.workflowStepStatus == domains.WorkflowStepStatus.ACTIVE || s.step.workflowStepStatus == domains.WorkflowStepStatus.CLAIMED)
                        //                && ((!i.currentSteps) ? i.currentSteps = s.name : i.currentSteps = i.currentSteps + ", " + s.name)));
                        //    }

                        // For each instance, build a linear representation for display in the grid
                        // We store this in linearLatestSteps array on the instance object
                        if (this.workflowInstances && this.workflowInstances.length > 0) {
                            this.workflowInstances.forEach(instance => {
                                this.buildInstanceLinearLatestSteps(instance);
                            });
                        }

                        //console.log("WORKFLOWINSTANCES", this.workflowInstances);
                        this.dgComponent.repaint();
                    }
                    this.dg.dataSource = this.workflowInstances;
                    // Iniialize detail ready array to false for all instances
                    if (this.workflowInstances?.length > 0) {
                        this.workflowInstances.forEach(i => this.workflowInstanceDetailReady.push(false));
                    }
                    this.workflowInstancesLoaded = true;
                }).
                catch(err => {
                    toastr.error("Cannot fetch workflow instances for this workflow master!" + err);
                });
        };

        loadWorkflowInstanceDetail(workflowInstanceId: number): void {
            var index = this.workflowInstances.findIndex(x => x.id === workflowInstanceId);

            if (this.selWorkflowIndex >= 0)
                this.workflowInstanceDetailReady[this.selWorkflowIndex] = false;
            this.selWorkflowIndex = index;

            this.workflowApi.getWorkflowInstance(workflowInstanceId)
                .then((response) => {
                    if (response.data) {
                        var workflowInstance: domains.IWorkflowInstance = response.data as domains.IWorkflowInstance;
                        this.workflowInstanceDetail[index] = angular.copy(workflowInstance);

                        //console.log("DETAIL SELECTED:", this.workflowInstanceDetail[index]);

                        // Connector labels may be in json format.
                        // If they are, convert to json string. This allows for labels to appear in multiple places on a connector
                        if (this.workflowInstanceDetail[index].diagram && this.workflowInstanceDetail[index].diagram.connectors) {
                            this.workflowInstanceDetail[index].diagram.connectors.forEach(co => {
                                if (co.text && co.text.charAt(0) == '{') {
                                    //console.log("PARSING JSON", angular.copy(co.text));
                                    try {
                                        const tmp = JSON.parse(co.text);
                                        co.text = tmp;
                                    } catch (e) {
                                    }
                                }
                            });
                        }
                        this.workflowInstanceDetailReady[index] = true;
                    }
                }).
                catch(err => {
                    toastr.error("Cannot fetch workflow instance details!");
                });
        };

        loadMonitor(workflowMasterId: number): void {
            this.loadWorkflowMasterAndInstances(workflowMasterId);
        }

        $onInit(): void {
            this.user = this.ids.getUser();

            this.isAdvisorUser = (
                this.user.role === "ADVISORY"
                || this.user.role === "ADVISORY_LEAD"
                || this.user.role === "ADVISORY_ADMIN"
            );

            this.isServicerUser = (
                this.user.role === "SERVICER_OPERATIONS"
                || this.user.role === "SERVICER_ADMIN"
            );

            this.isTraderUser = (
                this.user.role === "SERVICER_TRADER"
            );

            if (this.workflowMasterId)
                this.loadMonitor(this.workflowMasterId);
            if (this.iAmReady)
                this.iAmReady({ ctrl: this });
        }

        onUpdate = (e: any) => {
            // component, element, model, oldData, newData, key, 
            //console.log("Updating data...", e);

            const lifeCycleViewModel = {} as domains.AccountLifeCycleViewModel;

            lifeCycleViewModel.id = e.oldData.activities[0].id;
            lifeCycleViewModel.notes = e.newData["activities[0]"].notes;
            //console.log("NOTES ARE...", lifeCycleViewModel.notes);

            e.oldData.activities[0].notes = lifeCycleViewModel.notes;

            this.workflowApi.updateNotes(lifeCycleViewModel).then(response => {
                let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgChartAppTracker')) as DevExpress.ui.dxDataGrid;
                if (dg) {
                    dg.refresh();
                }
                toastr.success("Notes updated.");
            }, err => this.gs.showError(err));
        }

        onEditingStart = (e: any) => {
            // direct edit has been forbiden
            //console.log("In Editing Start...", e);
            //e.cancel = true;
        }

        onCellPrepared = (e: any) => {
            //console.log("OnCellPrepared Start", e);
            //if (e.rowType === "header" && e.column.index >= this.firstActivityColumnIndex && e.column.index < this.lastActivityColumnIndex) {
            //    //console.log("header....");
            //    e.cellElement.addClass("top-header");
            //}
            //else if (e.rowType === "data") {
            if (e.rowType === "data" && e.column.index > this.numVisibleFixedColumns) {
                // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
                const stepIndex = e.column.index - this.numVisibleFixedColumns - 1;
                const step = e.data.linearLatestSteps[stepIndex];
                let bgColorClass = "bg-danger";
                if (step != null && step.step != null) {
                    switch (step.step.workflowStepStatus) {
                        case domains.WorkflowStepStatus.CLAIMED:
                            bgColorClass = "bg-warning";
                            break;
                        case domains.WorkflowStepStatus.COMPLETED:
                            bgColorClass = "bg-success";
                            break;
                        case domains.WorkflowStepStatus.INACTIVE:
                            bgColorClass = "bg-info";
                            break;
                        default:
                            bgColorClass = "bg-danger"; // Active
                    }
                } else {
                    bgColorClass = "bg-info";
                }
                e.cellElement.removeClass().addClass(bgColorClass);
                e.cellElement.addClass("advisorop-gridcol");
            }
        }

        onContentReady = (e: any) => {
            // Notes column - allow servicer to edit
            //e.component.columnOption("Notes", "allowEditing", this.isServicerUser);
            //e.component.columnOption("Proposed Amount", "visible", this.showProposedAmount);
        }

        onClaimStep = (itm: any) => {
            if ((!this.isAutoCompleteActivity(itm)) || (confirm("Claiming an automated step... Are you sure ?"))) {

                // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
                const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
                //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
                const step = itm.data.linearLatestSteps[stepIndex];

                this.workflowApi.claimStep(step.step.id).then(response => {
                    // claiming an activity returns the entire instance
                    var instance = response.data;
                    this.buildInstanceLinearLatestSteps(instance);
                    this.workflowInstances[this.workflowInstances.findIndex(w => w.id == instance.id)] = instance;
                    //itm.cellElement.removeClass().addClass("bg-warning");
                    //itm.cellElement.addClass("advisorop-gridcol");
                }, err => this.gs.showError(err));
            }
        }

        onUnClaimStep = (itm: any) => {
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            this.workflowApi.unClaimStep(step.step.id).then(response => {
                // unclaiming an activity returns the entire instance
                var instance = response.data;
                this.buildInstanceLinearLatestSteps(instance);
                this.workflowInstances[this.workflowInstances.findIndex(w => w.id == instance.id)] = instance;
                //itm.cellElement.removeClass().addClass("bg-warning");
                //itm.cellElement.addClass("advisorop-gridcol");
            }, err => this.gs.showError(err));
        }

        onCompleteStep = (itm: any) => {
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            this.workflowApi.completeStep(step.step.id).then(response => {
                // completing an activity returns the entire instance
                var instance = response.data;
                this.buildInstanceLinearLatestSteps(instance);
                this.workflowInstances[this.workflowInstances.findIndex(w => w.id == instance.id)] = instance;
                //itm.cellElement.removeClass().addClass("bg-warning");
                //itm.cellElement.addClass("advisorop-gridcol");
            }, err => this.gs.showError(err));
        }

        onDecisionNegative = (itm: any) => {
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            this.workflowApi.decisionNegative(step.step.id).then(response => {
                // completing an activity returns the entire instance
                var instance = response.data;
                this.buildInstanceLinearLatestSteps(instance);
                this.workflowInstances[this.workflowInstances.findIndex(w => w.id == instance.id)] = instance;
                //itm.cellElement.removeClass().addClass("bg-warning");
                //itm.cellElement.addClass("advisorop-gridcol");
            }, err => this.gs.showError(err));
        }

        onDecisionPositive = (itm: any) => {
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            this.workflowApi.decisionPositive(step.step.id).then(response => {
                // completing an activity returns the entire instance
                var instance = response.data;
                this.buildInstanceLinearLatestSteps(instance);
                this.workflowInstances[this.workflowInstances.findIndex(w => w.id == instance.id)] = instance;
                //itm.cellElement.removeClass().addClass("bg-warning");
                //itm.cellElement.addClass("advisorop-gridcol");
            }, err => this.gs.showError(err));
        }

        onUndoStep = (itm: any) => {
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            this.workflowApi.undoCompleteStep(step.step.id).then(response => {
                // completing an activity returns the entire instance
                var instance = response.data;
                this.buildInstanceLinearLatestSteps(instance);
                this.workflowInstances[this.workflowInstances.findIndex(w => w.id == instance.id)] = instance;
            }, err => this.gs.showError(err));
        }

        onStealStep = (itm: any) => {
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            this.workflowApi.stealStep(step.step.id).then(response => {
                // completing an activity returns the entire instance
                var instance = response.data;
                this.buildInstanceLinearLatestSteps(instance);
                this.workflowInstances[this.workflowInstances.findIndex(w => w.id == instance.id)] = instance;
            }, err => this.gs.showError(err));
        }

        checkStepPermissionedRole(permissionedRole: number): boolean {
            //console.log("CHECKING...IsTraderUser", this.isTraderUser);
            //console.log("CHECKING...permissionedRole", permissionedRole);
            const ret = (this.isServicerUser && (!permissionedRole || permissionedRole == domains.WorkflowStepPermission.SERVICER))
                || (this.isTraderUser && permissionedRole == domains.WorkflowStepPermission.TRADER)
                || (this.isAdvisorUser && permissionedRole == domains.WorkflowStepPermission.ADVISOR);
            //console.log("RET...", ret);
            return ret;
        }

        canClaimTask = (itm: any) => {

            //console.log("IN CAN CLAIM", itm);

            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];
            if (step.step != null)
                return step.step.workflowStepStatus == domains.WorkflowStepStatus.ACTIVE
                    && step.type != constants.WORKFLOW_TERMINATOR
                    && this.checkStepPermissionedRole(step.stepPermissionedRole);
            else
                return false;
        }

        canStealTask = (itm: any) => {
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];
            if (step.step != null)
                return step.step.workflowStepStatus == domains.WorkflowStepStatus.CLAIMED
                    && step.type != constants.WORKFLOW_TERMINATOR
                    && step.step.responsibleUserId != this.user.id
                    && this.checkStepPermissionedRole(step.stepPermissionedRole);
            else
                return false;
        }

        showArchiveButton = (itm: any) => {
            if (this.isAdvisorUser)
                return false;

            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];
            if (step.step != null)
                return step.step.workflowStepStatus == domains.WorkflowStepStatus.ACTIVE
                    && step.type == constants.WORKFLOW_TERMINATOR
            else
                return false;
        }

        isAutoCompleteActivity = (itm: any) => {
            
            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];
            if (step.step != null)
                return (step.autoComplete == true && step.step.workflowStepStatus == domains.WorkflowStepStatus.ACTIVE);
            else
                return false;
        }

        isClaimedByMe = (itm: any) => {

            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];
            if (step.step != null)
                return (step.step.workflowStepStatus == domains.WorkflowStepStatus.CLAIMED && step.step.responsibleUserId === this.user.id);
            else
                return false;
        }

        isDecisionStep = (itm: any) => {

            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];
            if (step.step != null)
                return (step.type == constants.WORKFLOW_DECISION);
            else
                return false;
        }

        canUndo = (itm: any) => {

            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            // Check if there is an active or claimed process behind this process in the linear path
            // If one exists, we can not undo. This implies that at some point we took a step backward
            // and we do not want to undo steps that resulted in moving backward. Instead, the user can just
            // move forward again.
            var priorCompleteExists = false;
            const ind = itm.data.linearLatestSteps.findIndex(w => w.step && (w.step.workflowStepStatus == domains.WorkflowStepStatus.ACTIVE || w.step.workflowStepStatus == domains.WorkflowStepStatus.CLAIMED));
            if (ind >= 0 && ind < stepIndex)
                priorCompleteExists = true;

            return (step.step != null
                && step.step.isLatestCompletedStep
                && this.checkStepPermissionedRole(step.stepPermissionedRole)
                && !priorCompleteExists);
        }

        getActivityStatusText = (itm: any) => {

            // REMEMBER TO ALWAYS CONSIDER HIDDEN COLUMNS (need to add them in for the math to work, in this case we never include the start node in the grid, but it is in the array, so add 1)
            const stepIndex = itm.columnIndex - this.numVisibleFixedColumns + 1;
            //const stepIndex = itm.columnIndex - this.numVisibleFixedColumns;
            const step = itm.data.linearLatestSteps[stepIndex];

            if (step.step != null) {
                // Active step that I am not allowed to claim, indicate that we are waiting on another team
                if (step.step.workflowStepStatus === domains.WorkflowStepStatus.ACTIVE &&
                    step.stepPermissionedRole != null && step.stepPermissionedRole != undefined &&
                    (this.isServicerUser && step.stepPermissionedRole != domains.WorkflowStepPermission.SERVICER
                        || this.isTraderUser && step.stepPermissionedRole != domains.WorkflowStepPermission.TRADER
                        || this.isAdvisorUser && step.stepPermissionedRole != domains.WorkflowStepPermission.ADVISOR)) {
                    var team = "";
                    if (step.stepPermissionedRole == domains.WorkflowStepPermission.SERVICER)
                        team = "Servicer";
                    else if (step.stepPermissionedRole == domains.WorkflowStepPermission.TRADER)
                        team = "Trader";
                    else if (step.stepPermissionedRole == domains.WorkflowStepPermission.ADVISOR)
                        team = "Advisor";
                    return `<strong>Waiting for ${team} to claim</strong>`;
                } else if (step.step.workflowStepStatus === domains.WorkflowStepStatus.CLAIMED) {
                    return `${this.filter("date")(step.step.startDate, "shortDate")}<br /><strong>${step.step.responsibleUserName}</strong>`;
                } else if (step.step.workflowStepStatus === domains.WorkflowStepStatus.COMPLETED) {
                    return `${this.filter("date")(step.step.endDate, "shortDate")}<br /><strong>Done<br />${step.step.responsibleUserName}</strong>`;
                    //} else if (activity.activityStatus === domains.LifeCycleActivityStatus.SKIPPED) {
                    //    return `${this.filter("date")(activity.dateCreated, "shortDate")}<br /><strong>Skip</strong>`;
                } else {
                    return "";
                }
            } else {
                return "";
            }
        }

        //onSkipStep = (itm: any) => {
        //    const fldInd = this.getFieldIndex(itm.column.index);

        //    const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

        //    this.workflowApi.skipActivity(activity.id).then(response => {
        //        itm.data.activities[fldInd] = response.data;
        //        itm.cellElement.removeClass().addClass("bg-light-gray");
        //        itm.cellElement.addClass("advisorop-gridcol");
        //        //this.updateActivitiesCaptions();
        //    }, err => this.gs.showError(err));
        //}

        //onImpersonateActivity = (itm: any) => {
        //    // console.log(`Impersonating advisor...`);

        //    const fldInd = this.getFieldIndex(itm.column.index);

        //    const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

        //    if (!itm.data.advisorUsername) {
        //        this.gs.showError(`Missing Advisor's username`);
        //        return;
        //    }

        //    if (window.confirm(`Impersonate ${itm.data.advisorName} ?`)) {
        //        // authenticate servicer as advisor 
        //        this.ids.impersonateUser(itm.data.advisorUsername)
        //            .then(response => {
        //                // clear localstorage
        //                localStorage.clear();
        //                // redirect page to advisor dashboard if account is not open go into new account opening,
        //                // if open, go to account summary
        //                if (itm.row.data.accountStatus < this.accountStatusOpen)
        //                    window.location.href = `/advisor/newupdateaccount/${itm.data.accountId}`;
        //                else
        //                    window.location.href = `/advisor/accountsummary/${itm.data.accountId}`;
        //            }).catch(err => toastr.error(`Error ${err.status} ${err.data}`))
        //    }
        //}

        /**
* report: AssetAllocation, Holdings, Performance, Transactions
* level: will always be A-account or S-sleeve account
* */
        //openReport = (report: string, level: string, item: any) => {
        //    if (item.data.accountNumber) {
        //        //console.log(`Opening report ${report} on ${level} for account ${item.data.accountNumber}`);

        //        const ppParams = this.ads.calculatePpLevelAndClientId(level, null,
        //            item.data.accountNumber, null);

        //        //console.log(`PpParams: `, ppParams);

        //        this.ads.openPPReport(report, ppParams);
        //    } else {
        //        toastr.warning("This account has no account number");
        //    }
        //}
        //updateActivitiesCaptions(): void {
        //    if (this.apptrackerdata != undefined && this.activityDG != undefined) {
        //        this.countClaimedActivities();
        //        var values = Object.values(domains.AccActivtyId);
        //        values = values.slice(values.length / 2);
        //        values.forEach(value => {
        //            //let value = domains.AccActivtyId[key];
        //            let count = this.activitiesCounts[value];
        //            let caption = `${this.activityColumnHeadersPrefix[value]} (${count})`;
        //            this.activityDG.columnOption(`${value}`, "caption", caption)
        //        })
        //    }
        //}

                //showImpersonateButton = (itm: any) => {
        //    if (this.isAdvisorUser)
        //        return false;

        //    return false;
        //    //    //const fldInd = this.getFieldIndex(itm.columnIndex);
        //    //    const fldInd = this.getFieldIndex(itm.column.index);

        //    //    // Up to and including Link Acct
        //    //    return fldInd <= 4 && this.isClaimedByMe(itm);
        //}

        //showPPHoldingsButton = (itm: any) => {
        //    return false;

        ////    //const fldInd = this.getFieldIndex(itm.columnIndex);
        ////    const fldInd = this.getFieldIndex(itm.column.index);

        ////    // Funded / Invested
        ////    return (fldInd == 5 || fldInd == 6) && this.isClaimedByMe(itm);
        //}

        //countClaimedActivities(): void {
        //    this.activitiesCounts = {};
        //    let indexOfBillingStep = this.apptrackerdata[0].activities.findIndex(a => a.activityId == domains.AccActivtyId.ACCT_BILLING_SETUP);
        //    this.activitiesCounts = this.apptrackerdata.reduce((acc, account) => {
        //        for (let i = 0; i < account.activities.length; i++) {
        //            let a = account.activities[i];
        //            if (acc[a.activityId] == undefined) {
        //                acc[a.activityId] = 0;
        //            }
        //            if (a.activityStatus == domains.LifeCycleActivityStatus.CLAIMED || a.activityStatus == domains.LifeCycleActivityStatus.UNCLAIMED) {
        //                acc[a.activityId] += 1;
        //                if (a.activityId != domains.AccActivtyId.ACCT_BILLING_SETUP) {
        //                    let billingActivty = account.activities[indexOfBillingStep]
        //                    if (acc[domains.AccActivtyId.ACCT_BILLING_SETUP] == undefined) {
        //                        acc[domains.AccActivtyId.ACCT_BILLING_SETUP] = 0;
        //                    }
        //                    acc[domains.AccActivtyId.ACCT_BILLING_SETUP] += (billingActivty.activityStatus == domains.LifeCycleActivityStatus.CLAIMED || billingActivty.activityStatus == domains.LifeCycleActivityStatus.UNCLAIMED) ? 1 : 0;
        //                }
        //                break;
        //            }
        //        }
        //        return acc;
        //    }, {})
        //}
    }

    class WorkflowMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                workflowMasterId: "<",
                showMasterLabel: "<",
                iAmReady: "&",
            };
            this.controller = WorkflowMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/workflow-monitor.html';
        }
    }
    angular.module(Constants.APP).component("workflowMonitor", new WorkflowMonitor());
}